<template>
  <div class="feed-element">
    <div class="interaction-avatar pull-left">
      <img :src="interaction.ore.profile_image[0].value" @error="imageLoadOnError()" class="img-circle" v-if="interaction.ore.profile_image">
      <i class="fa fa-user-circle fa-3x" v-else></i>
      <div class="interaction-type img-circle" :class="interaction.type">
        <i class="fa fa-sm" :class="iconClasses[interaction.type]"></i>
      </div>
    </div>
    <div class="media-body">
      <small class="text-muted pull-right interaction-date">{{ interaction.date_created | moment('HH:MM Do MMM YYYY ') }}</small>
      <div class="interaction-originator">{{ interaction.ore.originators[0].value }}</div>
      <div class="interaction-media" v-if="mediaExists">
        <img v-if="interaction.ore.image" class="img-responsive" :src="getMediaValue(interaction, 'image')" />
        <video v-if="interaction.ore.video" :src="getMediaValue(interaction, 'video')" controls></video>
        <audio v-if="interaction.ore.audio" :src="getMediaValue(interaction, 'audio')" controls></audio>
      </div>
      <div class="interaction-message">{{ interaction.ore.message[0].value }}</div>
      <br/>
      <div class="interaction-tools">
        <a class="onair">
          <i class="fa fa-user"></i>
        </a>
        <a class="reply">
          <i class="fa fa-reply"></i>
        </a>
        <a class="comment">
          <i class="fa fa-comment"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Interaction',
  props: ['interaction'],
  data: () => ({
    iconClasses: {
      facebook_post: 'fa-facebook',
      facebook_comment: 'fa-comment',
      facebook_message: 'fa-facebook',
      twitter: 'fa-twitter',
      tweet: 'fa-twitter',
      instagram: 'fa-instagram',
      message: 'fa-mobile',
      sms: 'fa-mobile',
      whatsapp: 'fa-whatsapp',
      email: 'fa-envelope-o',
      titkok: 'fa-play-circle-o',
    },
  }),
  computed: {
    mediaExists() {
      return this.interaction.ore.image || this.interaction.ore.video || this.interaction.ore.audio;
    },
  },
  methods: {
    getMediaValue(interaction, mediaType) {
      /* eslint no-prototype-builtins :off */
      if (
        interaction.ore.hasOwnProperty(mediaType) &&
        interaction.ore[mediaType] &&
        interaction.ore[mediaType].length &&
        interaction.ore[mediaType][0].hasOwnProperty('value')
      ) {
        return interaction.ore[mediaType][0].value;
      }
      return '';
    },
    imageLoadOnError() {
      this.interaction.ore.profile_image[0].value =
        '/static/assets/icons/user/default_profile_normal.png';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.feed-element {
  padding: 10px 0;
  border-bottom: 1px $gallery solid;
}

.interaction-avatar {
  margin-right: 12px;
  color: $silver;
}

.facebook_message,
.facebook_post,
.facebook_comment {
  background-color: $chambray;
}

.message,
.sms {
  background-color: $curious-blue;
}

.whatsapp {
  background-color: $emerald;
}

.email {
  background-color: $carnation;
}

.twitter,
.tweet {
  background-color: $dodger-blue;
}

.instagram {
  background-color: $royal-purple;
}

.interaction-date {
  font-size: 9px;
}

.interaction-type {
  position: relative;
  width: 20px;
  height: 20px;
  color: $white-solid;
  top: -14px;
  left: 25px;
  font-size: 1.45rem;
  text-align: center;
}

.interaction-originator {
  font-weight: bold;
}

.interaction-tools {
  margin-top: 4px;

  a {
    padding-right: 3px;
    color: $mystic;
  }

  a.onair:hover {
    color: $radical-red;
  }

  a.reply:hover {
    color: $dodger-blue;
  }

  a.comment:hover {
    color: $jungle-green;
  }
}

.interaction-media {
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// Interaction.vue?ac274116